import createAction from 'redux-actions/es/createAction';

export const setCurrentLanguage = createAction('SET_CURRENT_LANGUAGE');
